import { render, staticRenderFns } from "./us-flag.vue?vue&type=template&id=072a2655&scoped=true&"
import script from "./us-flag.vue?vue&type=script&lang=js&"
export * from "./us-flag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a2655",
  null
  
)

export default component.exports